var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      return getIn(getFormState(state), form + '.asyncErrors');
    };
  };
};

export default createGetFormAsyncErrors;


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/selectors/getFormAsyncErrors.js
// module id = 2971
// module chunks = 3